import { BaseApplicantQualifiedAnswer } from './applicant-qualified-base-component';

export class TextBoxAnswer extends BaseApplicantQualifiedAnswer {
  notes: string;
  answerType = 'TextBoxAnswer';
}
